import React, { useState, useEffect } from "react"
 
import { getFront, getCities } from '../utils/api'
import Hero from "./Hero"
import MainImg from '../images/ent_main.png';

import headerLeft from '../images/israel-small.png';

import { PageConsumer } from '../context/theme'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';


export default function  Entitlement(){ 

  let [citiesObject, setCitiesObject] = useState('')
  let [defaultServices, setDefaultServices] = useState({defaultServicesArray: [], defaultServicesId: []}) 
  let [frontpageObject, setFrontpageObject] = useState('')
  const [value, setValue] = React.useState('');
  const [inputValue, setInputValue] = React.useState('');

  useEffect(
    () => {
      getCities().then(( citiesObjectEnd ) => { 
        citiesObjectEnd.cities.sort((a, b) => a.title.localeCompare(b.title));
        setCitiesObject( citiesObjectEnd.cities ) 
        setDefaultServices( {defaultServicesArray: citiesObjectEnd.default_cities_array, defaultServicesId: citiesObjectEnd.default_cities_id_array}) 
      }) 

      getFront().then(( frontpageObject ) => {
 
        setFrontpageObject( frontpageObject )
      })

    },
    []
  )
 
 
 


  return(
    <PageConsumer>

      {([currentPageObject]) =>
         
            ( frontpageObject && currentPageObject ) &&
              <Hero 
                frontpageObject = {frontpageObject}
                showTitle={false}
                image={MainImg}
                leftImage={headerLeft}
              > 
                  <div className="entitlement_page">
                    <h1 dangerouslySetInnerHTML={{__html: currentPageObject.acf.title}} /> 
                      

                    <h2  dangerouslySetInnerHTML={{__html: currentPageObject.acf.subtitle}}  />
                      
                    <div className="entitlement_page__content" dangerouslySetInnerHTML={{__html: currentPageObject.acf.paragraph}} />
                     
              
                    <div className="entitlement_page__select">
                      <h3 dangerouslySetInnerHTML={{__html: currentPageObject.acf.title_before_select}} />
                      <div className="entitlement_page__select_paragraph"  dangerouslySetInnerHTML={{__html: currentPageObject.acf.paragraph_after_select}} />

                      <div className="entitlement_page__select__container">
                        {
                          citiesObject &&
                          <Autocomplete
                            id="cities-select"
                            onChange={(event, newValue) => {
                              setValue(newValue);
                            }}
                            getOptionLabel={(option) => option.title}
                            options={citiesObject}
                            renderOption={(props, option) => (
                              <Box component="li" {...props}>
                                {option.title}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                data-id=""
                                label="עִיר"
                              
                                sx={{
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    borderRadius: 3,
                                    borderWidth: 3,
                                    borderColor: '#DBDBDB', // Change this to your desired border color
                                  },
                                  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#a5a4a4', // Change this to your desired border color on hover
                                  },
                                  '& .MuiInputBase-input': {
                                    color: '#4D4D4E',
                                    fontSize: '20px',
                                  },
                                }}
                              />
                            )}
                            clearOnBlur
                            PopperComponent={(props) => (
                              <Paper {...props} sx={{ backgroundColor: '#F4F4F4', position: 'absolute' }}>
                                {props.children}
                              </Paper>
                            )}
                          />

                        }
                      </div>
                      

                      <ul> 
                        {
                          defaultServices && defaultServices.defaultServicesArray && 
                           
                          
                          defaultServices.defaultServicesArray.map( (item) => {
                            return <li className="default_service" key={item.id}><a href={item.link} target="_blank" dangerouslySetInnerHTML={{__html: item.title}} /></li>
                          })
                          
                        }
                        {
                          value && value.pages && 
                              ( 
                             value.pages.map( (item) => {  
                           
                              if (!defaultServices.defaultServicesId.includes(String(item.id))) {
 
                                return <li key={item.id}><a href={item.link} target="_blank">{item.title}</a></li>
                              }
                              
                              return
                            })
                            ) 
                          
                        }
                      </ul>
                      <div className="entitlement_page__bottom_banner" dangerouslySetInnerHTML={{__html: currentPageObject.acf.bottom_banner}} />
                    </div>
                  </div>
              </Hero>
         
 
        }
      </PageConsumer>
  )
 
}

